var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.835,
    height: 129.271,
    viewBox: "0 0 82.835 129.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic",
    transform: "translate(-78.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629",
    transform: "translate(78.157 62.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M160.992,214.125a4.563,4.563,0,1,0-9.126,0,32.291,32.291,0,0,1-64.582,0,4.563,4.563,0,1,0-9.126,0,41.463,41.463,0,0,0,36.854,41.159v12.168H98.417a4.563,4.563,0,0,0,0,9.126h42.315a4.563,4.563,0,1,0,0-9.126H124.138V255.284A41.463,41.463,0,0,0,160.992,214.125Z",
    transform: "translate(-78.157 -209.562)",
    fill: "#FF0000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(94.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M157.363,0a25.447,25.447,0,0,0-25.447,25.447v41.2a25.447,25.447,0,0,0,50.894,0v-41.2A25.447,25.447,0,0,0,157.363,0Z",
    transform: "translate(-131.916)",
    fill: "#FF0000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicRed);
export default __webpack_public_path__ + "static/media/micRed.1d856d0ab677c39005cf8b4cf580d6cc.svg";
export { ForwardRef as ReactComponent };